import RoadsApi from '@/services/api/Roads'
import MapBox from '../services/MapBox'

export default {
  name: 'home',
  props: {
    siteName: String
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'NH Roads',
          disabled: false,
          href: '/'
        }
      ],
      randomRoad: {
        geoJson: {
          name:''
        }
      }
    }
  },
  async created() {
  },
  async mounted () {
    // load mapbox
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
    await this.loadRandomRoad();
    await this.buildMap();
  },
  methods: {
    async loadRandomRoad() {
      let road = await RoadsApi.getRandomRoad();
      this.randomRoad = road;
    },
    async buildMap() {
      let map = MapBox.createMap(),
          mapBounds = MapBox.getMapBounds(this.randomRoad.geoJson);

      map.on('load', () => {
          map.fitBounds(mapBounds, { padding: 60, duration: 0 });

        // road layer
        map.addLayer({
            'id': 'road',
            'type': 'line',
            'source': {
              'type': 'geojson',
              'data': this.randomRoad.geoJson
            },
            'paint': {
              'line-color': '#06D6A0',
              'line-width': 3,
              'line-opacity': .5
            }
        });
      });
    }
  }
}